import Toast from "react-bootstrap/esm/Toast";
import { useTranslation } from "react-i18next";
import { Variant } from "react-bootstrap/esm/types";

interface PropsInterface {
    variant: Variant;
    text: String;
    show: boolean;
    setShow: (bool: boolean) => void;
}

export default function InfoMessage({ variant, text, show, setShow }: PropsInterface) {
    const { t } = useTranslation();
    return (
        <div className="toast-container position-fixed bottom-0 end-0 p-3" id="AlertArea">
            <Toast bg={variant.toLocaleLowerCase()} onClose={() => setShow(false)} show={show} delay={5000} autohide>
                <Toast.Header>
                    <strong className="me-auto">{t("common.message")}</strong>
                </Toast.Header>
                <Toast.Body className="text-white">{text}</Toast.Body>
            </Toast>
        </div>
    );
}
